/* eslint-disable */
import axios from "axios";

// A API antiga devolve objectos com campo 'debug' misturado
// Esta função garante que o resultado é sempre um array limpo
function toArray(data) {
  if (!data) return [];
  if (Array.isArray(data)) return data;
  // O middleware do Slim adiciona um campo 'debug' ao JSON
  // Remover esse campo e converter o resto para array
  const clean = Object.entries(data)
    .filter(
      ([key, val]) =>
        key !== "debug" && typeof val === "object" && val !== null,
    )
    .map(([, val]) => val);
  return clean;
}

const instance = axios.create({
  baseURL: "https://leadcenter.pt/lead_center_v2_crm/api/public",
  timeout: 30000,
  headers: {
    "content-type": "application/json",
    "Authorization": "Basic YXBpX3ljX3VzZXI6ZTZLLzc1SjMpcFl+c153TA==",
  },
});

// ── De-duplicacao de pedidos simultaneos ────────────────────────────
// A pagina do dashboard tem dois componentes (o grafico do topo e a
// tabela de leads) a pedir /dashboard/listar/leads ao mesmo tempo.
// Eram dois POST identicos em paralelo; quando um falhava, ficava meia
// pagina vazia ate dar refresh.
// Aqui, pedidos iguais em voo partilham a mesma promessa.
const emVoo = new Map();

// Uma repeticao em caso de falha de rede — cobre falhas pontuais.
async function postar(url, data) {
  const chave = url + "|" + JSON.stringify(data || {});
  if (emVoo.has(chave)) return emVoo.get(chave);

  const p = (async () => {
    try {
      return await instance.post(url, data);
    } catch (e) {
      // Nao repetir se o servidor respondeu com erro (4xx/5xx) — so se
      // foi a ligacao que falhou; repetir um 4xx nao muda nada.
      if (e && e.response) throw e;
      await new Promise((r) => setTimeout(r, 700));
      return await instance.post(url, data);
    }
  })().finally(() => emVoo.delete(chave));

  emVoo.set(chave, p);
  return p;
}

export default {
  async login(data) {
    try {
      const r = await instance.post("/dashboard/login", data);
      return r.data;
    } catch (e) {
      console.error(e);
      return null;
    }
  },
  async listarLeads(data) {
    try {
      const r = await postar("/dashboard/listar/leads", data);
      return Array.isArray(r.data) ? r.data : toArray(r.data);
    } catch (e) {
      console.error(e);
      return null;
    }
  },
  // ── Leads com paginação no servidor ─────────────────────────────
  // { cliente, pagina, por_pagina, pesquisa } -> { total, pagina, por_pagina, leads: [] }
  async leadsPagina(data) {
    try {
      const r = await instance.post("/dashboard/leads/pagina", data);
      return r.data && Array.isArray(r.data.leads) ? r.data : null;
    } catch (e) {
      console.error(e);
      return null;
    }
  },
  // { cliente } -> { total, financiados, este_mes, organicas, facebook, google, por_mes: [12] }
  // Usa postar(): o gráfico e os contadores pedem-no ao mesmo tempo e partilham o pedido.
  async leadsResumo(data) {
    try {
      const r = await postar("/dashboard/leads/resumo", data);
      return r.data && typeof r.data.total !== "undefined" ? r.data : null;
    } catch (e) {
      console.error(e);
      return null;
    }
  },
  // { cliente, email, de?, ate? } -> { resultado, details }  (o XLSX chega por email)
  async exportarLeads(data) {
    try {
      const r = await instance.post("/dashboard/leads/exportar", data);
      return r.data;
    } catch (e) {
      console.error(e);
      return e && e.response && e.response.data
        ? e.response.data
        : { resultado: "NOK", details: "Erro de ligação" };
    }
  },
  async listarLeadsIncumprimento(data) {
    try {
      const r = await postar(
        "/dashboard/listar/leads/incumprimento",
        data,
      );
      return Array.isArray(r.data) ? r.data : toArray(r.data);
    } catch (e) {
      console.error(e);
      return null;
    }
  },
  async converterLead(data) {
    try {
      const r = await instance.post("/dashboard/converter/leads", data);
      return r.data;
    } catch (e) {
      console.error(e);
      return null;
    }
  },
  // RGPD — nova tabela rgpd_consentimentos
  async listarConsentimentos(data) {
    try {
      const r = await postar("/reorganiza/rgpd/listar", data);
      return Array.isArray(r.data) ? r.data : toArray(r.data);
    } catch (e) {
      console.error(e);
      return null;
    }
  },
  async listarTaxas(data) {
    try {
      const r = await postar("/dashboard/taxa/listar/todas", data);
      return Array.isArray(r.data) ? r.data : toArray(r.data);
    } catch (e) {
      console.error(e);
      return null;
    }
  },
  async atualizarTaxas(data) {
    try {
      const r = await instance.post("/dashboard/taxa/atualizar", data);
      return r.data;
    } catch (e) {
      console.error(e);
      return null;
    }
  },
  async listarConsultores(data) {
    try {
      const r = await postar("/dashboard/consultor/listar/todos", data);
      return Array.isArray(r.data) ? r.data : toArray(r.data);
    } catch (e) {
      console.error(e);
      return null;
    }
  },
  async atualizarProdutoConsultor(data) {
    try {
      const r = await instance.post(
        "/dashboard/consultor/produto/atualizar",
        data,
      );
      return r.data;
    } catch (e) {
      console.error(e);
      return null;
    }
  },
  async apagarConsultor(data) {
    try {
      const r = await instance.post("/dashboard/consultor/apagar", data);
      return r.data;
    } catch (e) {
      console.error(e);
      return null;
    }
  },
  async adicionarConsultor(data) {
    try {
      const r = await instance.post("/dashboard/consultor/adicionar", data);
      return r.data;
    } catch (e) {
      console.error(e);
      return null;
    }
  },
  async atualizarFeriasConsultor(data) {
    try {
      const r = await instance.post(
        "/dashboard/consultor/ferias/atualizar",
        data,
      );
      return r.data;
    } catch (e) {
      console.error(e);
      return null;
    }
  },
};
